import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=695f4145&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f4145",
  null
  
)

export default component.exports